import { render, staticRenderFns } from "./NameList.vue?vue&type=template&id=4927c915&"
import script from "./NameList.vue?vue&type=script&lang=js&"
export * from "./NameList.vue?vue&type=script&lang=js&"
import style0 from "./NameList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports